// @ts-expect-error TypeScript can find declaration file, but import still works
import mux from 'mux-embed'
import { VideoSourceInfo } from './iVideoManager'
import { IVideoManager } from './iVideoManager'
import { whenTrackingAllowed } from '../../components/consent/consentTrackingStore'

const MUX_ENV_KEY = process.env.NEXT_PUBLIC_REACT_APP_MUX_ENV_KEY

export class NativeHLSVideoManager implements IVideoManager {
    // Mux Data writes its `muxData` viewer cookie and beacons to litix.io as
    // soon as it monitors an element, so monitoring waits for consent.
    private cancelPendingMuxMonitor: (() => void) | null = null

    constructor() {}

    attachInstance(videoObject: VideoSourceInfo) {
        const videoElement = videoObject.videoRef?.current
        if (!videoElement) return
        videoElement.src = videoObject.manifestUrl
        videoElement.load()
        this.muxMonitor(videoObject)
    }

    muxMonitor(videoObject: VideoSourceInfo) {
        const videoElement = videoObject.videoRef?.current
        if (!videoElement) return

        const { playerVideo } = videoObject

        this.cancelPendingMuxMonitor?.()
        this.cancelPendingMuxMonitor = whenTrackingAllowed(() => {
            mux.monitor(videoElement, {
                debug: false,
                data: {
                    env_key: MUX_ENV_KEY,

                    // Player Metadata
                    player_name: 'vlp',
                    player_init_time: Date.now(),

                    // Video Metadata
                    video_id: playerVideo.videoHash,
                    video_title: playerVideo.name,
                    video_duration: playerVideo.duration,
                    video_stream_type: 'on-demand',

                    // Custom Metadata
                    custom_1: playerVideo.clientName,
                    custom_2: 'native-hls',
                },
            })
        })
    }
    detachInstance(videoObject: VideoSourceInfo) {
        this.cancelPendingMuxMonitor?.()
        this.cancelPendingMuxMonitor = null
        const videoElement = videoObject.videoRef?.current
        if (!videoElement) return

        videoElement.pause()
        videoElement.removeAttribute('src')
        videoElement.load()
    }
}
